import { Dispatch, ReactElement, SetStateAction, createContext, useState } from 'react';

export type SearchContextType = {
  searchText: string | undefined;
  setSearchText: Dispatch<SetStateAction<string | undefined>>;
};

export const ctxSearch = createContext<SearchContextType | undefined>(undefined);

export function SearchContext({ children }: { children: ReactElement }) {
  const [searchText, setSearchText] = useState<string | undefined>(undefined);

  return (
    <ctxSearch.Provider
      value={{
        searchText,
        setSearchText,
      }}
    >
      {children}
    </ctxSearch.Provider>
  );
}
